import ExecAPI from 'appRoot/api/api';

/**
 * Gets the power status of the user's IPMI device.
 * @returns {Promise} Promise that delivers the user's IPMI device power status.
 */
export function GetIpmiPowerStatus()
{
	return ExecAPI("UserIpmiData/GetIpmiPowerStatus");
}
/**
 * Sets the power status of the user's IPMI device.
 * @param {String} action Power action.
 * @returns {Promise} Promise that delivers the result of the operation.
 */
export function SetIpmiPowerStatus(action)
{
	return ExecAPI("UserIpmiData/SetIpmiPowerStatus", { action });
}
/**
 * Gets the current IPMI connection information.
 * @returns {Promise} Promise that delivers the user's IPMI connection information.
 */
export function GetIpmiConnectionInformation()
{
	return ExecAPI("UserIpmiData/GetIpmiConnectionInformation");
}
/**
 * Sets up temporary IPMI access to the user's machine from the specified source IP address.
 * @param {String} ip Public IPv4 address of the machine the user wants to use to connect to the IPMI device.
 * @returns {Promise} Promise that delivers the user's IPMI connection information.
 */
export function SetupIpmiConnectionInformation(ip)
{
	return ExecAPI("UserIpmiData/SetupIpmiConnectionInformation", { ip });
}